import React from 'react';
import ServicePage from '../components/ServicePage';
import { pageContent as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';

const Residential = () => {
  const { pageContent = fb } = useContent();
  return <ServicePage data={pageContent.residential} />;
};
export default Residential;
